export const endpointMocks = {
  COMMON: {
    DASHBOARD_BFF_URL: '/login/login/getDashBrdData',
    LOGIN_URL: '/login/loginPage',
    LOGOUT_URL: '/login/login/logout',
    LOGOUT_TIMEOUT: '5000'
  }
};
